import { getNamePrefixs, getRoles } from "./../js/dropdown-service";
import { InputType } from "./../js/constants";


export function getView() {
    return [
        [
            {
                name: "namePrefix",
                text: "คำนำหน้า",
                type: InputType.dropdown,
                data: {
                    promise: getNamePrefixs(),
                    url: ""
                },
                rule: {
                    required: true
                }
            },
            {
                name: "firstName",
                text: "ชื่อ",
                type: InputType.text,
                rule: {
                    required: true
                }
            },
            {
                name: "lastName",
                text: "สกุล",
                type: InputType.text,
                rule: {
                    required: true
                }
            }
        ],
        [
            {
                name: "email",
                text: "Email",
                type: InputType.text,
                rule: {
                    required: true,
                    //email: true
                }
            },
            {
                name: "role",
                text: "Role",
                type: InputType.dropdown,
                disabled: true,
                rule: {
                    required: true
                }
            },
            {
                type: InputType.offset
            }
        ],
        [
            {
                type: "section",
                text: "Credential"
            }
        ],
        [
            {
                name: "userName",
                text: "User Name",
                type: InputType.text,
                disabled: true,
                rule: {
                    required: true,
                    min: 5,
                    max: 10
                }
            },
            {
                type: InputType.offset
            },
            {
                type: InputType.offset
            },
            {
                type: InputType.offset
            }
        ]
    ]
}


